import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { Menu } from "primereact/menu";
import React, { useMemo, useRef, useState } from "react";
import { FaEllipsisH } from "react-icons/fa";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import "./GroupeCardPublication.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loader from "Components/Loader/loader";
import GroupeCardCommentaire from "../GroupeCardCommentaire/GroupeCardCommentaire";
import { InputTextarea } from "primereact/inputtextarea";
import { Controller, useForm } from "react-hook-form";
import { updateGroups } from "Redux/Actions/groupsActions";
import axios from "axios";
import { fetchGet, useFetchGetPagination } from "Services/api";
import { Button } from "primereact/button";
import neutralUser from "assets/neutralUser.png";
import { useEffect } from "react";
import { DateTime } from "luxon";

const GroupeCardPublication = (props) => {
  const [commentairesURL, setCommentairesURL] = useState(undefined);
  const commentairesQuery = useFetchGetPagination(
    commentairesURL,
    props.auth.token
  );
  const [commentaires, setCommentaires] = useState([]);
  const [voirPlus, setVoirPlus] = useState({
    state: false,
    amount: 3,
  });

  const [isGroupAdmin, setIsGroupAdmin] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      content: "",
      publication: undefined,
    },
  });

  const fillPublicationData = async () => {
    let publicationsList = await fetchGet("/publications", props.auth.token);
    props.handleUpdateGroups({
      publications: publicationsList,
    });
  };

  const updateState = () => {
    fillPublicationData();
  };

  const handleDisableComments = async () => {
    props.setDisableComments({
      state: true,
      id: props.publication.id,
    });
  };

  /**
   * Fonction qui permet d'envoyer une requête post pour créer un commentaire
   * @param {{content: string, publication: string}} data données du formulaire
   * @returns {void}
   */
  const postComment = (data) => {
    let response = undefined;
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}${"/publication_comments"}`,
        data,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then((res) => (response = res))
      .catch((error) => {
        props.setResponse(error.response);
      })
      // Si tout s'est bien passé, on reset le formulaire
      .finally(() => {
        if (response) {
          reset();
          updateState();
          props.setResponse(response);
        }
      });
  };

  /**
   *  Fonction qui va remplir la propriété publication avec la publication actuelle
   * @param {{content: string, publication: string}} data données du formulaire
   * @returns {{content: string, publication: string}} données du formulaire avec champ sourceGroup renseigné
   */
  const assignPublication = (data) => {
    data = {
      ...data,
      publication: "/api/publications/" + props.publication.id.toString(),
    };
    return data;
  };

  const onSubmit = (data) => {
    data = assignPublication(data);
    postComment(data);
  };

  /**
   * Affichage d'une erreur si nécessaire dans le formulaire
   * @param {String} name nom du champ
   * @returns {JSX.Element}
   */
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && (
        <small
          className="p-error"
          style={{ display: "grid", textAlign: "center" }}
        >
          {errors[name].message}
        </small>
      )
    );
  };

  const menuTop = useRef(null);
  let adminMenu = [
    {
      label: "Supprimer",
      command: () =>
        props.setDeleteAction({
          id: props.publication.id,
          type: "publication",
          state: true,
          visible: true,
        }),
    },
    { separator: true },
    {
      label: "Désactiver les commentaires",
      command: () => handleDisableComments(),
    },
  ];

  let ownerMenu = [
    {
      label: "Modifier",
      command: () =>
        props.setEditPublication({
          id: props.publication.id,
          state: true,
          visible: true,
          content: props.publication.content,
        }),
    },
    { separator: true },
    {
      label: "Supprimer",
      command: () =>
        props.setDeleteAction({
          id: props.publication.id,
          type: "publication",
          state: true,
          visible: true,
        }),
    },
    { separator: true },
    {
      label: "Désactiver les commentaires",
      command: () => handleDisableComments(),
    },
  ];

  const userMenu = [
    {
      label: "Signaler",
      command: () =>
        props.setReportAction({
          id: props.publication.id,
          type: "publication",
          state: true,
          visible: true,
        }),
    },
  ];

  // EN fonction de si les commentaires sont déjà désactivés ou non, on affiche ou non les deux derniers éléments des menus
  adminMenu =
    props.publication && props.publication.availableForComments
      ? adminMenu
      : adminMenu.splice(0, adminMenu.length - 2);
  ownerMenu =
    props.publication && props.publication.availableForComments
      ? ownerMenu
      : ownerMenu.splice(0, ownerMenu.length - 2);

  function makeCommentsUrl(id) {
    let url = process.env.REACT_APP_BASE_URL_API;
    url += "/publication_comments";
    url = new URL(url);
    url.searchParams.append("publication", id);
    url.searchParams.append("order[createdAt]", "ASC");
    url.searchParams.append("itemsPerPage", 90);
    setCommentairesURL(url);
  }

  async function checkUserIsGroupAdmin() {
    // Construction de l'url pour récupérer les rôles de l'utilisateur dans le groupe
    let url = process.env.REACT_APP_BASE_URL_API;
    url += "/group_members";
    url = new URL(url);
    url.searchParams.append("user", props.auth.userConnected.id);
    url.searchParams.append("groupSource", props.publication.sourceGroup.id);

    // Récupération des rôles de l'utilisateur dans le groupe
    let groupMember = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + props.auth.token,
        Accept: "application/json",
      },
    });

    // Vérification si l'utilisateur est un administrateur du groupe
    let find = false;
    if (groupMember.data && groupMember.data.length > 0)
      find = groupMember.data[0].groupMemberRoles.find(
        (member) => member.role.roleName == "ROLE_GROUP_ADMIN"
      );
    if (find) setIsGroupAdmin(true);
    else setIsGroupAdmin(false);
  }

  async function downloadFile(url, token) {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          accept: "application/json",
        },
        responseType: "blob",
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        const link = document.createElement("a");
        link.download = props.publication.document.slice(
          props.publication.document.lastIndexOf("/") + 1
        );
        link.href = blobUrl;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        }, 100);
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  }

  // On crée l'url des commentaires à chaque fois que la publication change
  useMemo(async () => {
    if (props.publication) {
      makeCommentsUrl(props.publication.id);
      await checkUserIsGroupAdmin();
    }
  }, [props.publication]);

  // On récupère les commentaires à chaque fois que la query change
  useEffect(() => {
    if (commentairesQuery.loaded && commentairesQuery.data) {
      setCommentaires(commentairesQuery.data);
    }
  }, [commentairesQuery]);

  return (
    <>
      <div className="groupe_comment">
        {props.publication ? (
          <>
            <div className="groupe_comment__top">
              <div className="groupe_comment__top__container">
                <div className="groupe_comment__top__container__user">
                  <img
                    src={
                      props.publication.user.imageUrl
                        ? props.publication.user.imageUrl
                        : neutralUser
                    }
                    alt="Avatar"
                    title="Avatar"
                  />
                  <h5>
                    {`${props.publication.user.firstname} ${props.publication.user.surname}`}
                    <span className="groupe_comment__top__container__user-date">
                      {new Intl.DateTimeFormat("fr-FR", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                        hour: "numeric",
                        minute: "numeric",
                      }).format(
                        DateTime.fromISO(props.publication.createdAt).toJSDate()
                      )}
                      {"  "}
                      {props.publication.updatedAt ? "(modifié)" : ""}
                    </span>
                  </h5>
                  <h5>{props.publication.user.imageUrl}</h5>
                </div>
                {!props.finder && (
                  <div className="groupe_comment__top__container__right">
                    <Menu
                      appendTo={document.getElementById("app")}
                      // Affichage du menu en fonction du rôle de l'utilisateur
                      model={
                        // Vérification si l'utilisateur n'est pas le créateur de la publication
                        props.publication.user.id != props.auth.userConnected.id
                          ? // Si oui, vérification si l'utilisateur est un administrateur ou non
                            props.auth.isAdmin || isGroupAdmin
                            ? adminMenu
                            : userMenu
                          : ownerMenu
                      }
                      popup
                      ref={menuTop}
                      style={{ textAlign: "left" }}
                    />
                    <BtnBlanc
                      btnAction={(event) => menuTop.current.toggle(event)}
                    >
                      <FaEllipsisH size={"1.5rem"} />
                    </BtnBlanc>
                  </div>
                )}
              </div>
              {props.publication?.content}
              {props.publication?.document && !props.finder && (
                <div className="groupe_comment__top__file">
                  <div
                    className="groupe_comment__top__file-link"
                    onClick={async () =>
                      await downloadFile(
                        `${process.env.REACT_APP_BASE_URL_API}/publications/${props.publication.id}/download`,
                        props.auth.token
                      )
                    }
                  >
                    {/* On récupère le nom du fichier dans l'url */}
                    <strong>
                      {props.publication.document.slice(
                        props.publication.document.lastIndexOf("/") + 1
                      )}
                    </strong>
                  </div>
                </div>
              )}
            </div>
            {props.publication.availableForComments && !props.finder && (
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="groupe_comment__form"
              >
                <div className="groupe_comment__bottom">
                  <img
                    src={
                      props.auth.userConnected.imageUrl
                        ? props.auth.userConnected.imageUrl
                        : neutralUser
                    }
                    className="groupe_comment__bottom-avatar"
                    alt="Mon avatar"
                    title="Mon avatar"
                  />
                  <Controller
                    name="content"
                    control={control}
                    rules={{
                      required: "Veuillez renseigner le contenu du commentaire",
                    }}
                    render={({ field }) => (
                      <InputTextarea
                        {...field}
                        className="groupe_comment__bottom-message"
                        placeholder="Laisser un commentaire"
                        rows={10}
                        cols={30}
                        autoResize
                      />
                    )}
                  />
                  <BtnBleu
                    className="groupe_comment__bottom-button"
                    btnTexte="Publier"
                  />
                </div>
                {getFormErrorMessage("content")}
              </form>
            )}
          </>
        ) : (
          <Loader />
        )}
        <div className="groupe_comment__messages">
          {props.publication &&
            props.setDeleteAction &&
            props.setEditComment &&
            props.setReportAction &&
            commentaires &&
            commentaires
              .slice(0, voirPlus.amount)
              .map((comment) => (
                <GroupeCardCommentaire
                  key={comment.id}
                  comment={comment}
                  currentUser={props.auth.userConnected}
                  setDeleteComment={props.setDeleteAction}
                  setEditComment={props.setEditComment}
                  setReportComment={props.setReportAction}
                  isGroupAdmin={isGroupAdmin}
                />
              ))}
          {commentaires.length > voirPlus.amount && (
            <Button
              label="Voir plus de commentaires"
              className="p-button-text commentaires-bouton"
              onClick={() => setVoirPlus({ amount: voirPlus.amount + 3 })}
            ></Button>
          )}
        </div>
      </div>
    </>
  );
};

GroupeCardPublication.propTypes = {
  publication: PropTypes.object,
  groups: PropTypes.object,
  auth: PropTypes.object,
  handleUpdateGroups: PropTypes.func,
  setResponse: PropTypes.func,
  comments: PropTypes.array,
  setDeleteAction: PropTypes.func,
  deleteAction: PropTypes.object,
  setEditComment: PropTypes.func,
  editComment: PropTypes.object,
  setEditPublication: PropTypes.func,
  editPublication: PropTypes.object,
  setReportAction: PropTypes.func,
  setDisableComments: PropTypes.func,

  //? Si le composant est utilisé dans la recherche de groupe
  finder: PropTypes.bool,
};

GroupeCardPublication.defaultProps = {
  finder: false,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  groups: state.groups,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateGroups: (value) => {
    dispatch(updateGroups(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupeCardPublication);
